import React from "react";
import { motion } from "framer-motion";

const ITEMS = [
  "לא פלטפורמת Resale (ספסרות מודרנית).",
  "לא אתר כרטיסים גנרי שנלחם בבוטים.",
  "לא הגרלה שמבוססת על מזל בלבד.",
];

export default function WhatWeAreNot() {
  return (
    <section className="pt-20 md:pt-28" style={{ background: "#121212" }}>
      <div className="max-w-3xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2
            className="font-bold text-white mb-4"
            style={{ fontSize: "clamp(1.75rem, 3vw, 3rem)" }}
          >
            בואו נעשה סדר
          </h2>
          <p className="text-lg mb-10" style={{ color: "#FFFFFF" }}>
            כדי להבין את המהפכה,
            <br />
            חשוב לדעת ש-MOM3NTUM היא לא:
          </p>
        </motion.div>

        <div className="space-y-4 mb-10">
          {ITEMS.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.4 }}
              className="flex flex-col items-center gap-2"
            >
              <img
                src="/images/giveaway/not_sign.svg"
                alt=""
                className="w-8 h-8"
              />
              <p className="text-lg md:text-xl text-white">{item}</p>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-lg md:text-xl leading-relaxed font-bold text-white"
        >
          אנחנו מערכת ניהול גישה. אנחנו בונים
          <br />
          עדיפות לאנשים אמיתיים שרוצים להיות שם.
        </motion.p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.2 }}
        className="mt-16 -mb-0"
      >
        <img
          src="/images/giveaway/shutterstock_2764831401.png"
          alt="קהילת MOM3NTUM"
          className="w-full"
          style={{ display: "block" }}
        />
      </motion.div>
    </section>
  );
}
